// frontend/src/FlutterwavePayment.js
import React, { useEffect, useState } from 'react';
import { useFlutterwave, closePaymentModal } from 'flutterwave-react-v3';
import { useNavigate } from 'react-router-dom';
import './FlutterwavePayment.css';

const FlutterwavePayment = () => {
  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  // Load pending payment from localStorage
  useEffect(() => {
    const storedPayment = localStorage.getItem('pendingPayment');
    if (storedPayment) {
      setPaymentData(JSON.parse(storedPayment));
    } else {
      alert('No pending payment found!');
      navigate('/dashboard');
    }
  }, [navigate]);

  // Hook is called unconditionally with temporary config
  const handleFlutterwavePayment = useFlutterwave({
    public_key: process.env.REACT_APP_FLUTTERWAVE_PUBLIC_KEY || '',
    tx_ref: 'temp-ref', // temporary, replaced on actual payment
    amount: 0,
    currency: 'KES',
    payment_options: 'card,mobilemoney,ussd',
    customer: { email: '', phonenumber: '', name: '' },
    customizations: {
      title: 'Moonlanding Technologies Ltd',
      description: '',
      logo: 'https://moonlandingtechnologies.co.ke/logo.png',
    },
  });

  if (!paymentData) return <p>Loading payment details...</p>;

  const handlePayment = async () => {
    setIsProcessing(true);

    // Construct actual config with paymentData
    const txRef = `sr-${paymentData.id || 'unknown'}-${Date.now()}`;
    const config = {
      public_key: process.env.REACT_APP_FLUTTERWAVE_PUBLIC_KEY,
      tx_ref: txRef,
      amount: paymentData.amount,
      currency: paymentData.currency || 'KES',
      payment_options: 'card,mobilemoney,ussd',
      customer: {
        email: paymentData.customer?.email || 'customer@example.com',
        phonenumber: paymentData.customer?.phone || '',
        name: paymentData.customer?.name || 'Customer',
      },
      customizations: {
        title: 'Moonlanding Technologies Ltd',
        description: paymentData.description,
        logo: 'https://moonlandingtechnologies.co.ke/logo.png',
      },
    };

    handleFlutterwavePayment({
      ...config,
      callback: async (response) => {
        closePaymentModal(); // always close the modal
        console.log('Payment Response:', response);

        if (response.status === 'successful') {
          try {
            // Send the response to your backend for verification
            const res = await fetch(
              `${process.env.REACT_APP_API_BASE_URL}/payments/flutterwave-webhook/`,
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(response),
              }
            );

            if (res.ok) {
              alert('Payment successful! Your service request is confirmed.');
              localStorage.removeItem('pendingPayment');
              navigate('/dashboard');
            } else {
              const errorData = await res.json();
              console.error('Server verification failed:', errorData);
              alert('Payment succeeded, but server verification failed.');
            }
          } catch (err) {
            console.error('Webhook error:', err);
            alert('Payment succeeded, but there was a server issue. Contact support.');
          }
        } else {
          alert('Payment not completed.');
        }

        setIsProcessing(false);
      },
      onClose: () => {
        console.log('Payment modal closed');
        setIsProcessing(false);
      },
    });
  };

  return (
    <div className="flutterwave-payment-container">
      <h1>Flutterwave Payment</h1>
      <p>
        <strong>Amount:</strong> KES {paymentData.amount}
      </p>
      <p>
        <strong>Description:</strong> {paymentData.description}
      </p>
      <button onClick={handlePayment} disabled={isProcessing}>
        {isProcessing ? 'Processing Payment...' : 'Pay Now via Flutterwave'}
      </button>
    </div>
  );
};

export default FlutterwavePayment;
